var _templateObject;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { createGlobalStyle } from "styled-components";
import { FONTS_CDN_URL } from "../constants";
var BRAND_CDN_URL = "".concat(FONTS_CDN_URL, "/aanz");
var FONT_FAMILY = "FS Lola";
export var AanzFonts = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @font-face {\n    font-family: ", ";\n    src: url(", "/fs_lola_web-extrabold.woff2) format('woff2'),\n    url(", "/fs_lola_web-extrabold.woff) format('woff');\n    font-weight: 800;\n    font-style: normal;\n    font-display: swap;\n  }\n\n  @font-face {\n    font-family: ", ";\n    src: url(", "/fs_lola_web-bold.woff2) format('woff2'),\n    url(", "/fs_lola_web-bold.woff) format('woff');\n    font-weight: 700;\n    font-style: normal;\n    font-display: swap;\n  }\n"])), FONT_FAMILY, BRAND_CDN_URL, BRAND_CDN_URL, FONT_FAMILY, BRAND_CDN_URL, BRAND_CDN_URL);